/**
 * API配置工具
 * 提供统一的API URL获取方法
 */

// 获取API基础URL
export function getBaseApiUrl() {
  // 使用配置文件中的productionUrl
  const protocol = window.location.protocol;
  return `${protocol}//${window.productionUrl}`;
} 